import { createUseStyles } from '../../../../../../../theming';
import MomentUtils from '@date-io/moment';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React, { FC } from 'react';
import moment, { Moment } from 'moment';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    alignItems: 'baseline',
    '& > div': {
      marginRight: 5,
      marginLeft: 5,
    },
  },
  datePicker: {
    maxWidth: 150,
  },
});

interface Props {
  startDate: string | null;
  endDate: string | null;
  onStartDateChange: (date: string | null) => void;
  onEndDateChange: (date: string | null) => void;
}

const DateRangePicker: FC<Props> = ({ startDate, endDate, onEndDateChange, onStartDateChange }) => {
  const classes = useStyles();

  const formatDate = (date: Moment | null) => (date ? date.format('YYYY-MM-DD') : null);
  const momentDate = (date: string | null) => (date ? moment(date, 'YYYY-MM-DD') : null);

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <div className={classes.root}>
        <DatePicker
          className={classes.datePicker}
          label='Date&nbsp;de&nbsp;début'
          format='DD/MM/YYYY'
          value={momentDate(startDate)}
          onChange={(date) => onStartDateChange(formatDate(date))}
        />
        <div>à</div>
        <DatePicker
          className={classes.datePicker}
          label='Date&nbsp;de&nbsp;fin'
          format='DD/MM/YYYY'
          value={momentDate(endDate)}
          onChange={(date) => onEndDateChange(formatDate(date))}
        />
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default DateRangePicker;
